import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueRouter from 'vue-router'
import VueSidebarMenu from './index'
import store from './store'
import SvgIcon from 'vue-svgicon'
import axios from 'axios'
import swal from 'sweetalert';

import {
    faArchive,
    faCheckCircle,
    faChild,
    faCircle,
    faCoffee,
    faDownload,
    faExchangeAlt,
    faExternalLinkAlt,
    faSave,
    faUnlockAlt
} from '@fortawesome/free-solid-svg-icons'
import {dom, library} from '@fortawesome/fontawesome-svg-core'
import {faTwitter} from '@fortawesome/free-brands-svg-icons'
import {FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText} from '@fortawesome/vue-fontawesome'
import {faPlusCircle} from "@fortawesome/free-solid-svg-icons/faPlusCircle";
import {faMinusCircle} from "@fortawesome/free-solid-svg-icons/faMinusCircle";
import {faPoll} from "@fortawesome/free-solid-svg-icons/faPoll";
import {faQuestion} from "@fortawesome/free-solid-svg-icons/faQuestion";
import {faBars} from "@fortawesome/free-solid-svg-icons/faBars";
import {faSuitcase} from "@fortawesome/free-solid-svg-icons/faSuitcase";
import {faUsers} from "@fortawesome/free-solid-svg-icons/faUsers";
import {faUserCircle} from "@fortawesome/free-solid-svg-icons/faUserCircle";
import {faKey} from "@fortawesome/free-solid-svg-icons/faKey";
import {faPlug} from "@fortawesome/free-solid-svg-icons/faPlug";
import {faTrash} from "@fortawesome/free-solid-svg-icons/faTrash";
import {faPrint} from "@fortawesome/free-solid-svg-icons/faPrint";
import {faTint} from "@fortawesome/free-solid-svg-icons/faTint";
import {faRecycle} from "@fortawesome/free-solid-svg-icons/faRecycle";
import {faCloud} from "@fortawesome/free-solid-svg-icons/faCloud";
import {faHandsHelping} from "@fortawesome/free-solid-svg-icons/faHandsHelping";
import {faListUl} from "@fortawesome/free-solid-svg-icons/faListUl";
import {faLock} from "@fortawesome/free-solid-svg-icons/faLock";
import {faCog} from "@fortawesome/free-solid-svg-icons/faCog";
import {faQuestionCircle} from "@fortawesome/free-solid-svg-icons/faQuestionCircle";
import {faTrophy} from "@fortawesome/free-solid-svg-icons/faTrophy";
import {faExclamationTriangle} from "@fortawesome/free-solid-svg-icons/faExclamationTriangle";
import {faSkullCrossbones} from "@fortawesome/free-solid-svg-icons/faSkullCrossbones";
import {faWindowClose} from "@fortawesome/free-regular-svg-icons";
import {faListAlt} from "@fortawesome/free-solid-svg-icons/faListAlt";
import {faMedkit} from "@fortawesome/free-solid-svg-icons/faMedkit";
import {faChevronDown} from "@fortawesome/free-solid-svg-icons/faChevronDown";
import {faChevronUp} from "@fortawesome/free-solid-svg-icons/faChevronUp";
import {faThumbsUp} from "@fortawesome/free-solid-svg-icons/faThumbsUp"
import {faThumbsDown} from "@fortawesome/free-solid-svg-icons/faThumbsDown";
import {faUserLock} from "@fortawesome/free-solid-svg-icons/faUserLock";
import {faChessQueen} from "@fortawesome/free-solid-svg-icons/faChessQueen";
import {faPencilAlt} from "@fortawesome/free-solid-svg-icons/faPencilAlt";
import {faList} from "@fortawesome/free-solid-svg-icons/faList";
import {faSignInAlt} from "@fortawesome/free-solid-svg-icons/faSignInAlt";
import {faGavel} from "@fortawesome/free-solid-svg-icons/faGavel";
import {faPenSquare} from "@fortawesome/free-solid-svg-icons/faPenSquare";
import {faWineBottle} from "@fortawesome/free-solid-svg-icons/faWineBottle";

import Toasted from 'vue-toasted';
import router from "./router";
import {faTimes} from "@fortawesome/free-solid-svg-icons/faTimes";
import {faTimesCircle} from "@fortawesome/free-solid-svg-icons/faTimesCircle";
import {faLink} from "@fortawesome/free-solid-svg-icons/faLink";
import {faEnvelopeOpen} from "@fortawesome/free-solid-svg-icons/faEnvelopeOpen";
import {faCheck} from "@fortawesome/free-solid-svg-icons/faCheck";
import {faUserPlus} from "@fortawesome/free-solid-svg-icons/faUserPlus";
import {faPlus} from "@fortawesome/free-solid-svg-icons/faPlus";
import {faUmbrella} from "@fortawesome/free-solid-svg-icons/faUmbrella";
import {faStickyNote} from "@fortawesome/free-solid-svg-icons/faStickyNote";
import {faMailBulk} from "@fortawesome/free-solid-svg-icons/faMailBulk";
import {faTools} from "@fortawesome/free-solid-svg-icons/faTools";

Vue.use(Toasted,  {iconPack: 'custom-class'})

library.add(
    faCoffee,
    faChild,
    faCircle,
    faDownload,
    faArchive,
    faTwitter,
    faUnlockAlt,
    faPlusCircle,
    faMinusCircle,
    faBars,
    faPoll,
    faQuestion,
    faSuitcase,
    faUsers,
    faUserCircle,
    faKey,
    faCheckCircle,
    faPlug,
    faTrash,
    faPrint,
    faTint,
    faRecycle,
    faCloud,
    faHandsHelping,
    faListUl,
    faLock,
    faCog,
    faListAlt,
    faChevronDown,
    faChevronUp,
    faThumbsUp,
    faThumbsDown,
    faUserLock,
    faTrophy,
    faExclamationTriangle,
    faSkullCrossbones,
    faWindowClose,
    faMedkit,
    faCoffee,
    faChessQueen,
    faPencilAlt,
    faQuestionCircle,
    faList,
    faSignInAlt,
    faUsers,
    faGavel,
    faListUl,
    faPenSquare,
    faExclamationTriangle,
    faWineBottle,
    faTimes,
    faTimesCircle,
    faLink,
    faExchangeAlt,
    faExternalLinkAlt,
    faEnvelopeOpen,
    faSave,
    faCheck,
    faUserPlus,
    faPlus,
    faChild,
    faUmbrella,
    faStickyNote,
    faMailBulk,
    faTools
);

dom.watch();
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.component('font-awesome-layers-text', FontAwesomeLayersText);

Vue.component('VineyardMenuItemV2Editor', require('./components/vineyard/editor/VineyardMenuItemV2Editor.vue'))
Vue.component('draggable', require('vuedraggable'))

Vue.use(VueRouter);
Vue.use(VueSidebarMenu);
Vue.use(SvgIcon, {
    tagName: 'svgicon'
})

Vue.config.productionTip = false;
Vue.use(BootstrapVue);

export const bus = new Vue();


const appVersion = process.env.VUE_APP_VERSION;
console.log("App Version: " + appVersion);
const base = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    withCredentials: true
});

let myRouter = router;
base.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (401 === error.response.status) {
        swal({
            title: "Session Expired",
            text: "Your session has expired. Would you like to be redirected to the login page?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes",
            closeOnConfirm: false
        })
            .then(() => {
                localStorage.clear();
                myRouter.push({name: 'Login'})
                    .catch(pushError => {
                        console.log("There was an issue: " + pushError)
                    });
            });
    } else {
        return Promise.reject(error);
    }
});

base.interceptors.request.use(config => {
    config.headers['X-App-Version'] = String(process.env.VUE_APP_VERSION || 'unknown');
    return config;
});

export const globalStore = new Vue({
    data: {
        isAdmin: false
    }
});

Vue.prototype.$http = base;
Vue.prototype.$appVerion = appVersion;



new Vue({
    el: "#app",
    render: h => h(App),
    router,
    store
})
    .$mount('#app');
